<template>
  <section class="admin-content " id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-dark m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">

            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <strong>DB Cleaner</strong>
            </div>

          </div>
        </div>
      </div>
      <section class="">

        <div class="col-md-12">
          <b-card no-body>
            <b-tabs pills card align="center">

              <b-tab title="Duplicate Enrollees" active>
                <b-card-text>
                  <!-- <div class="row list"> -->
                  <DuplicateUsers />
                  <!-- </div> -->
                </b-card-text>
              </b-tab>

              <b-tab title="Null Sector">
                <b-card-text>
                  <EnrolleenoSector />
                </b-card-text>
              </b-tab>

              <b-tab title="Duplicate ID Card Number">
                <b-card-text>
                  <DuplicateIDCardNumber />
                </b-card-text>
              </b-tab>

              <b-tab title="Bulk Upload">
                <b-card-text>
                  <BulkUpload />
                </b-card-text>
              </b-tab>



            </b-tabs>
          </b-card>
        </div>

      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from '@/views/Navbar.vue'
  import DuplicateUsers from "@/views/clients/DuplicateUsers";
  import EnrolleenoSector from "./components/EnrolleenoSector";
  import DuplicateIDCardNumber from "./components/DuplicateIDCardNumber";
  import BulkUpload from "./components/BulkUpload";

  export default {
    components: {
      Navbar, EnrolleenoSector, DuplicateIDCardNumber, BulkUpload, DuplicateUsers
    },
    data() {
      return {
        user: null,

        edit: false,
        show: false,

        agency_id: "",


      }
    },
    beforeMount() {
      //
    },

    methods: {



    },
    created() {
      //
    }

  }
</script>